export const AssetCalculationRoutes = {
    ROOT: "/asset-calculation"
};


// WEBPACK FOOTER //
// ./src/components/assetCalculation/AssetCalculationRoutes.ts